import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=28185948&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"
import style0 from "./pending.vue?vue&type=style&index=0&id=28185948&prod&lang=scss"
import style1 from "./pending.vue?vue&type=style&index=1&id=28185948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28185948",
  null
  
)

export default component.exports